var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"viewer-actions-item",attrs:{"title":_vm.item.subtitle}},[_c(_vm.item.icon,{tag:"Component",staticClass:"transform scale-80"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }